import React, { useEffect, useState } from 'react'
import RightContent from '../../components/OnBoard/RightContent'
import styles from "./UserOnboarding2.module.css"
import UserOnboardingSteps from '../../components/OnBoard/UserOnboardingSteps'
import style from "./BusinessDetailsOverseas.module.css"
import { Country, State } from 'country-state-city'
import { useLocation, useNavigate } from 'react-router-dom'
import CompanyBillingAddress from './CompanyBillingAddress'
import API from "../../ApiConfig"
import { GET_GSTIN_DETAILS, GET_PAN_STATUS, GSTIN_ADDRESSES, SIGNUP_VERIFER } from '../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix'
import AnimatedLoader from '../../components/AnimationLoader'
import { GSTIN_REGEX, PAN_REGEX, PASSWORD_CHECK, PHONE_CHECK, PIN_REGEX } from '../../Utils/helper'
import Icon from 'react-icons-kit'
import { basic_eye } from 'react-icons-kit/linea/basic_eye'
import { basic_eye_closed } from 'react-icons-kit/linea/basic_eye_closed'
const CompanyDetailsOnshore = () => {
    const allCountries = Country.getAllCountries();
    const [form, setForm] = useState({
      gstin:"", pan: "", company: "", addr1: "", addr2: "", country: "India", zip: "", state:"", city:"", password:"", confirmPassword:"", phoneNumber:""
    })
    const set = (k) => (e) => {
        let value = e.target.value;
        if (k === "gstin" || k === "pan") value = value.toUpperCase();
        setForm(f => ({ ...f, [k]: value }));
        if (errors[k]) setErrors(prev => ({ ...prev, [k]: "" }))
      }
    const navigate=useNavigate()
    const user_data=JSON.parse(localStorage.getItem("user_data"))
    const States = form.country?State.getStatesOfCountry("IN"): []
    const location=useLocation()
    const options=[{
        id:1,
        title:"Same as above address",
        subText:"Use the registered GST address for all invoices"
    },
    {
        id:2,
        title:"Add Address",
        subText:"Select from other addresses registered under this GSTIN"
    }
]
    const [errors, setErrors] = useState({})
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [selectedBillingAddressId, setBillingAddressId]=useState("")
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null)
    const [loading, setLoading]=useState(false)
    const [companyLocations, setCompanyLocations]=useState([])
    const [addressesLoading, setAddressesLoading] = useState(false)
    const [showsetBillingOptions, setShowSetBillingOptions]=useState(false)

      useEffect(() => {
        if (!location.state?.isGstinRegistered) return;
        if (form.gstin.length !== 15) return;
     
        if (!GSTIN_REGEX.test(form.gstin)) {
          setErrors(prev => ({ ...prev, gstin: "Invalid GSTIN format" }))
          return;
        }
     
        const timer = setTimeout(() => getGstinDetails(), 500);
        return () => clearTimeout(timer);
      }, [form.gstin])

      
      const getGstinDetails = () => {
        setLoading(true)
        setErrors(prev => ({ ...prev, gstin: "" }))

        API.get(GET_GSTIN_DETAILS + form.gstin)
            .then(res => {
                setLoading(false)
                if (res.data.status == 200) {
                  setErrors({})
                    const d = res.data.data || {};
                    setForm(prev => ({
                        ...prev,
                        company: d.company_name || d.legal_name_of_business || "",
                        addr1: d.address1 || "",
                        addr2: d.address2 || "",
                        city: d.city || "",
                        state: d.state_name || "",
                        zip: d.pin_code || "",
                        country: d.country || "India",
                    }))

                    setShowSetBillingOptions(true)
                    getGSTINAddresses(form.gstin)
                    cogoToast.success("GSTIN details fetched successfully")
                } else {
                    setForm(prev => ({
                        ...prev,
                        company: "", addr1: "", addr2: "",
                        city: "", state: "", zip: "", country: "India",
                    }))
                    const msg = res.data.message || "Invalid GSTIN";
                    setErrors(prev => ({ ...prev, gstin: msg }))
                    cogoToast.error(msg)
                }
            })
            .catch(err => {
                setLoading(false)
                setForm(prev => ({
                    ...prev,
                    company: "", addr1: "", addr2: "",
                    city: "", state: "", zip: "", country: "India",
                }))
                const msg=err.response?.data?.message
                cogoToast.error(msg || "Failed to fetch GSTIN details")
            })
    }

    const handleBillingAddressSave = (billingData) => {
        setSelectedBillingAddress(billingData);
      }

      useEffect(() => {
        setShowSetBillingOptions(false)
        setCompanyLocations(null)
        setSelectedBillingAddress(null)
        if (selectedBillingAddressId == 2) setBillingAddressId("")
      }, [form.gstin])


      const getGSTINAddresses = (gstin) => {
        const gstinToUse = gstin || form.gstin
        if (!gstinToUse || gstinToUse.length !== 15) return

        setAddressesLoading(true)
        API.get(GSTIN_ADDRESSES + gstinToUse)
          .then(res => {
            setAddressesLoading(false)
            if (res.status == 200) {
              const data = res.data?.data?.addresses
              setCompanyLocations(data)
            } else {
              setCompanyLocations([])
            }
          })
          .catch(err => {
            setAddressesLoading(false)
            setCompanyLocations([])
            const msg = err?.response?.data?.message || "Failed to fetch GSTIN addresses"
          })
      }


    const handleSubmit=(e)=>{
        e.preventDefault()
        if (!user_data?.email) {
            cogoToast.error("Session expired. Please restart registration.")
            navigate("/app/Onboarding")
            return;
          }
        if (!ValidateForm()) {
            cogoToast.error("Please fix the errors in the form")
            return;
          }
        let apiData={
            email: user_data.email,
            jurisdiction_type: "onshore",
            company_name: form.company,
            phone_number: `+91${form.phoneNumber}`,
            address1: form.addr1,
            address2: form.addr2,
            country: form.country,
            pincode: form.zip,
            password: form.password,
            confirm_password: form.confirmPassword,
            registration_type: location.state.isGstinRegistered?"gst_registered":"gst_unregistered",
            city: form.city,
            state: form.state,
            gstin:location.state.isGstinRegistered?form.gstin:null,
            billing_address_option: selectedBillingAddressId==1?"same":"add",
            pan: location.state.isGstinRegistered?null:form.pan
          }
          if (selectedBillingAddressId == 2) {
            apiData.selected_billing_address = selectedBillingAddress;
          }
          
          setLoading(true)
        API.post(SIGNUP_VERIFER,apiData)
        .then(res=>{
            setLoading(false)
            if(res.data.status==200){
                cogoToast.success(res.data.message)
                navigate("/app/registration/step3")
            }
            else {
                cogoToast.error(res.data.message || "Something went wrong")
              }
        })
        .catch((err=>{
          if(err.response.status==408){
            setLoading(false)
            cogoToast.error(err?.response?.data?.message)
            navigate("/app/Onboarding")
          }
          else{
          setLoading(false)
          cogoToast.error(err?.response?.data?.message || "Something went wrong")
          }
            
        }))
    }


    useEffect(() => {
        if (form.pan.length !== 10) return;
     
        if (!PAN_REGEX.test(form.pan)) {
          setErrors(prev => ({ ...prev, pan: "Invalid PAN format (e.g. ABCDE1234F)" }))
          return;
        }
     
        const timer = setTimeout(() => getPanStatus(), 500);
        return () => clearTimeout(timer);
      }, [form.pan])


    const getPanStatus=()=>{
        setLoading(true)
        setErrors(prev => ({ ...prev, pan: "" }))
        API.get(GET_PAN_STATUS + form.pan)
        .then(res=>{
          setLoading(false)
          if(res.data.status==200){
            cogoToast.success("PAN verified successfully")
            setForm(prev=>({
                ...prev,
                company:res.data?.data?.name
            }))
          }
          else{
            const msg = res.data.message || "Error in PAN number";
            setErrors(prev => ({ ...prev, pan: msg }))
            cogoToast.error(msg)
          }
        })
        .catch(err=>{
            setLoading(false)
            setForm(prev=>({
              ...prev,
              company:  "",
              addr1: "",
              addr2:"",
              city:"",
              state:"",
              zip:"",
              country:"India"

          }))
            const msg = err?.response?.data?.message || "Failed to verify PAN";
            setErrors(prev => ({ ...prev, pan: msg }))
            cogoToast.error(msg)
          
        })
      }


      const ValidateForm=()=>{
        const newErrors = {}
        const isGst = location.state?.isGstinRegistered
        if (isGst) {
            if (!form.gstin.trim()) newErrors.gstin = "GSTIN is required";
            else if (form.gstin.length !== 15) newErrors.gstin = "GSTIN must be 15 characters";
            else if (!GSTIN_REGEX.test(form.gstin)) newErrors.gstin = "Invalid GSTIN format";
          }
          else {
            if (!form.pan.trim()) newErrors.pan = "PAN is required";
            else if (!PAN_REGEX.test(form.pan)) newErrors.pan = "Invalid PAN format (e.g. ABCDE1234F)";
          }
          if (!form.company.trim()) newErrors.company = "Company name is required";
          else if (form.company.trim().length<3) newErrors.company = "Company name is too short";
          if (!form.password) newErrors.password = "Password is required"
          else if (!PASSWORD_CHECK(form.password)) newErrors.password="Your password should be between 8 to 13 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character"
          if (!form.confirmPassword) newErrors.confirmPassword = "Please confirm your password";
          else if (form.password !== form.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
          if (!form.phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
          if (!PHONE_CHECK(form.phoneNumber.trim())) {
            newErrors.phoneNumber = "Enter a valid 10-digit Indian mobile number";
          }
          if (!form.addr1.trim()) newErrors.addr1 = "Address Line 1 is required";
          if (form.addr1.trim().length > 100) {
            newErrors.addr1 = "Address Line 1 cannot exceed 100 characters";
          }
          if(form.addr1.trim().length<3){
            newErrors.addr1 = "Address Line 1 should have minumum 3 characters"
          }
          if (!form.addr2.trim()) newErrors.addr2 = "Address Line 2 is required"
          if (form.addr2.trim().length > 100) {
            newErrors.addr2 = "Address Line 2 cannot exceed 100 characters";
          }
          if(form.addr2.trim().length<3){
            newErrors.addr2 = "Address Line 2 should have minumum 3 characters"
          }
          if (!form.city.trim()) newErrors.city = "City is required";
          if (!form.state) newErrors.state = "Please select a state";
          if (!form.zip.trim()) newErrors.zip = "Pincode is required";
          else if (!PIN_REGEX.test(form.zip.trim())) newErrors.zip = "Pincode must be 6 digits";

          if (isGst) {
            if (!selectedBillingAddressId) {
              newErrors.billing = "Please select a billing address option";
            } else if (selectedBillingAddressId == 2 && !selectedBillingAddress) {
              newErrors.billing = "Please select and save a billing address";
            }
          }
          setErrors(newErrors)
    return Object.keys(newErrors).length === 0;
      }


  return (
    <div className={styles.userOnboarding}>
        <AnimatedLoader isOpen={loading} loadingText={"Please Wait..."}/>
        <RightContent step={3} />
     <section className={styles.leftContent}>
            <div className={styles.progressForm} style={{height:"100%",width:"75%"}}>
              <div className={styles.progressForm1}>
              <div className={styles.onboardingStep}>
                        <UserOnboardingSteps stepNo={2}/>
                    </div>
                <div className={styles.headingHelperText}>
                    <h1 className={styles.heading} style={{fontSize:"30px", textAlign:"left"}}>Business Details</h1>
                    <div>
                        <p className={styles.supportingText} style={{textAlign:"center", marginTop:"0px"}}>Enter your business details and tax information.</p>
                    </div>
                     <div className={styles.emailContainer} style={{width:"100%"}}>
 
              <div className={style.anFormRow}>
            {location.state.isGstinRegistered&&    <div className={style.anFormGroup}>
                  <label className={style.anLabel}>GSTIN <span style={{color:"red"}}>*</span></label>
                <input
                className={style.anInput}
                placeholder="eg. 3RZHGP4605L6Z8"
                value={form.gstin}
                onChange={set("gstin")}
                maxLength={15}
              />
              {errors.gstin && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.gstin}</span>
                      )}
                </div>}
                {!location.state.isGstinRegistered&&   <div className={style.anFormGroup}>
                  <label className={style.anLabel}>PAN (Permanant Account Number) <span style={{color:"red"}}>*</span></label>
                <input
                        className={style.anInput}
                        placeholder="eg. ABCDE1234F"
                        value={form.pan}
                        onChange={set("pan")}
                        maxLength={10}
                    />


              {errors.pan && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.pan}</span>
                      )}
                </div>}
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Company Name <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="Legal registered name"
                    value={form.company}
                    onChange={set("company")}
                    disabled
                  />
                  {errors.company && (
                      <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.company}</span>
                    )}
                </div>
              </div>
              

              <div className={style.anFormRow}>
                              <div className={style.anFormGroup}>
                                <label className={style.anLabel}>Password <span style={{color:"red"}}>*</span></label>
                                <div className={style.anInput} style={{position:"relative"}}>
                                <input
                                type={showPassword?"text":"password"}
                                  placeholder="e.g. 123456789"
                                  value={form.password}
                                  onChange={set("password")}
                                  style={{
                                        width: "100%",
                                        height:"46px",
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        padding: "0px",
                                        fontSize: "14px",
                                        }}
                                />
                                <span
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                      position: "absolute",
                                                      right: 12,
                                                      top: "50%",
                                                      transform: "translateY(-50%)",
                                                      cursor: "pointer",
                                                      color: "#6b7280",
                                                      display: "flex",
                                                      alignItems: "center",
                                                  }} ><Icon icon={showPassword? basic_eye:basic_eye_closed} size={20}/></span>
                                </div>
                                {errors.password && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.password}</span>
                      )}
                              </div>
                              <div className={style.anFormGroup}>
                                <label className={style.anLabel}>Confirm Password <span style={{color:"red"}}>*</span></label>
                                <div className={style.anInput} style={{position:"relative"}}>
                                <input
                                type={showConfirmPassword?"text":"password"}
                                  placeholder="eg. 123456789"
                                  value={form.confirmPassword}
                                  onChange={set("confirmPassword")}
                                  style={{
                                    width: "100%",
                                    height:"46px",
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    padding: "0px",
                                    fontSize: "14px",
                                    }}
                                />
                                <span
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    style={{
                                                      position: "absolute",
                                                      right: 12,
                                                      top: "50%",
                                                      transform: "translateY(-50%)",
                                                      cursor: "pointer",
                                                      color: "#6b7280",
                                                      display: "flex",
                                                      alignItems: "center",
                                                  }} ><Icon icon={showConfirmPassword? basic_eye:basic_eye_closed} size={20}/></span>
                                </div>
                                {errors.confirmPassword && (
                      <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.confirmPassword}</span>
                    )}
                              </div>
                            </div>
                    <div>
                        <p className={styles.supportingText} style={{color:"#1a56db",margin:"15px 0px", fontWeight:"500"}}>REGISTERED ADDRESS</p>
                    </div>
              <div className={style.anFormGroup}>
                <label className={style.anLabel}>Address Line 1 <span style={{color:"red"}}>*</span></label>
                <input
                  className={style.anInput}
                  placeholder="Street address or P.O. Box"
                  value={form.addr1}
                  onChange={set("addr1")}
                />
                {errors.addr1 && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.addr1}</span>
                      )}
              </div>
 
              <div className={style.anFormGroup}>
                <label className={style.anLabel}>Address Line 2 <span style={{color:"red"}}>*</span></label>
                <input
                  className={style.anInput}
                  placeholder="Apartment, suite, unit, building, floor, etc."
                  value={form.addr2}
                  onChange={set("addr2")}
                />
                {errors.addr2 && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.addr2}</span>
                      )}
              </div>
              <div className={style.anFormRow}>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>City <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="Enter City"
                    value={form.city}
                    onChange={set("city")}
                    disabled={location.state.isGstinRegistered}
                  />
                  {errors.city && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.city}</span>
                      )}
                </div>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>State <span style={{color:"red"}}>*</span></label>
                  <div className={style.anSelectWrap}>
                    <select
                      className={`${style.anSelect}${form.countryCode ? style.hasValue : ""} ${style.disabled}`}
                      value={form.state}
                      onChange={set("state")}
                      disabled={location.state.isGstinRegistered}
                    >
                      <option value="">Select State</option>
                      {allCountries &&States && States.map(c => <option key={c.isoCode} value={c.name}>{c.flag} {c.name}</option>)}
                    </select>
                  </div>
                  {errors.state && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.state}</span>
                      )}
                </div>
              </div>
              <div className={style.anFormRow}>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>Country <span style={{color:"red"}}>*</span></label>
                  <div className={style.anSelectWrap}>
                    <select
                      className={`${style.anSelect}${form.countryCode ? style.hasValue : ""} ${style.disabled} `}
                      value={form.country}
                      onChange={set("country")}
                      disabled
                    >
                      <option value="">Select country</option>
                      {allCountries &&allCountries.map(c => <option key={c.isoCode} value={c.name}>{c.flag} {c.name}</option>)}
                    </select>
                  </div>
                  {errors.country && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.country}</span>
                      )}
                </div>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>Pin Code <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="6-digits PIN"
                    value={form.zip}
                    onChange={set("zip")}
                    disabled={location.state.isGstinRegistered}
                  />
                  {errors.zip && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.zip}</span>
                      )}
                </div>

                <div className={style.anFormGroup}>
                                <label className={style.anLabel}>Phone Number <span style={{color:"red"}}>*</span></label>
  <div className={style.anInput} style={{ display: "flex", alignItems: "center", padding: 0, overflow: "hidden" }}>
    <span
      style={{
        padding: "0 12px",
        height: "46px",
        display: "flex",
        alignItems: "center",
        background: "#e5e7eb",
        color: "#374151",
        fontSize: "14px",
        fontWeight: 500,
        borderRight: "1px solid #d1d5db",
        userSelect: "none",
        cursor: "not-allowed",
      }}
    >
      +91
    </span>
    <input
      type="tel"
      inputMode="numeric"
      pattern="[0-9]*"
      placeholder="9876543210"
      value={form.phoneNumber}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, "");
        setForm(f => ({ ...f, phoneNumber: digits }));
        if (errors.phoneNumber) setErrors(prev => ({ ...prev, phoneNumber: "" }));
      }}
      maxLength={10}
      style={{
        flex: 1,
        height: "46px",
        border: "none",
        outline: "none",
        background: "transparent",
        padding: "0 12px",
        fontSize: "14px",
        minWidth: 0,
      }}
    />
</div>
                                {errors.phoneNumber && (
                      <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.phoneNumber}</span>
                    )}
                              </div>
              </div>
            {showsetBillingOptions && location.state.isGstinRegistered &&<>  <div>
                    <p className={styles.supportingText} style={{color:"#1a56db",margin:"15px 0px", fontWeight:"500"}}>BILLING ADDRESS</p>
              </div>
            <div className={style.anFormRow}>
                {options.map((i,index)=>(
                    <div
                      key={i.id}
                      onClick={() => {
                        if (addressesLoading) return
                        setBillingAddressId(i.id)
                        if (errors.billing) setErrors(prev => ({ ...prev, billing: "" }))
                      }}
                      className={styles.billingAddress}
                    >
                        <div>
                          <input
                            type='radio'
                            name='option'
                            value={i.id}
                            checked={selectedBillingAddressId==i.id}
                            disabled={addressesLoading}
                            onChange={() => setBillingAddressId(i.id)}
                          />
                        </div>
                        <div>
                        <div className={styles.supportingText} style={{margin:"0px", color:"black"}}>{i.title}</div>
                        <div className={styles.supportingText} style={{marginTop:"0px"}}>{i.subText}</div>
                        </div>
                    </div>
                ))}
              </div>
              {errors.billing && (
                        <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>{errors.billing}</span>
                      )}
              </>}
              <div className={style.anActions} style={{ marginTop: 32 }}>
                <button className={style.anBtnBack} onClick={()=>navigate("/app/registration/onshore-status")} disabled={loading}> Go Back</button>
                <button className='btn btn-primary' onClick={(e)=>handleSubmit(e)} disabled={loading}>{loading ? "Saving..." : "Save & Continue"}</button>
              </div>
            </div>

            {selectedBillingAddressId == 2 && (
              form.gstin.length === 15 ? (
                <CompanyBillingAddress
                  data={companyLocations || []}
                  onSave={handleBillingAddressSave}
                  state={form.state||""}
                />
              ) : (
                <div style={{
                  width: "100%",
                  padding: "12px 16px",
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 6,
                  color: "#b91c1c",
                  fontSize: 16,
                  marginTop: 16,
                  marginBottom: 16,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}>
                  <span>⚠</span>
                  {form.gstin === ""
                    ? "Please enter a GSTIN to view available billing addresses"
                    : "Please enter a complete 15-character GSTIN"}
                </div>
              )
            )}
                    </div>
                    </div>
                </div>
     </section>
     </div>
  )
}

export default CompanyDetailsOnshore